import * as React from 'react';
import cn from 'classnames';
import { TInputType } from '@cian/ui-kit/input/types';
import { Button } from '@cian/ui-kit/button';
import { InfoText } from '../InfoText';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as styles from './styles.css';
import { FormInputsLayout } from '../../../FormInputsLayout';

export interface IPhoneFieldProps {
  value: string;
  isValid: boolean;
  error: string;
  fetching: boolean;

  onChange(value: string): void;

  onSubmit(value: string): void;
}

export const PhoneField: React.FC<IPhoneFieldProps> = ({ value, onChange, error, isValid, onSubmit, fetching }) => {
  const deviceType = useDeviceType();
  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value), [
    onChange,
  ]);

  const handleSubmit = React.useCallback(() => onSubmit(value), [onSubmit, value]);

  const containerClassNames = React.useMemo(
    () =>
      cn(styles['container'], {
        [styles['mobile']]: deviceType === 'phone',
      }),
    [deviceType],
  );

  return (
    <div className={containerClassNames}>
      <FormInputsLayout
        InputProps={{
          invalid: !!error,
          type: 'tel' as TInputType,
          placeholder: '+7',
          onChange: handleChange,
          disabled: fetching,
          errorMessage: error,
          value,
        }}
        fullwidth
      />
      <div className={styles['submit']}>
        <Button size={'M'} disabled={!isValid} onClick={handleSubmit} loading={fetching}>
          Дальше
        </Button>
      </div>
      <div className={styles['info']}>
        <InfoText />
      </div>
    </div>
  );
};

PhoneField.displayName = 'PhoneField';
